import { createFileRoute, redirect } from '@tanstack/react-router'
import z from 'zod'

const searchParamsSchema = z.object({
  t: z.number().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/$alias/_app/contact-logs/$contactLogId',
)({
  validateSearch: searchParamsSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$alias/interaction/$contactLogId',
      params: {
        alias: params.alias,
        contactLogId: params.contactLogId,
      },
      search: search,
    })
  },
})
